export default __webpack_public_path__ + "static/project-zimmer2-6b38a0dcb1830bacdbc4c2f3de4d9348.png";